import type { Dayjs } from "dayjs";

const SHIFTS_CACHE_KEY_REGEX =
	/^caregiverAppGetShifts-(undefined|\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}(?:Z|[+-]\d{2}:\d{2})?)-(undefined|\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}(?:Z|[+-]\d{2}:\d{2})?)$/;

export function parseShiftsCacheKey(key: string) {
	const match = key.match(SHIFTS_CACHE_KEY_REGEX);
	if (!match) return null;
	return {
		after: match[1] === "undefined" ? undefined : match[1],
		before: match[2] === "undefined" ? undefined : match[2],
	};
}

// changes in selectedTimestamp can cause unnecessary cache misses, so he we compute a more stable timestamp to use as the query cursor.
// the idea is the query is not refetched unless the user selects a timestamp beyond some threshold in the past or future.
// The primary motivation behind this optimization is for smoother offline caching in the mobile app.
export function getStableShiftsQueryAfterCursor(selectedTimestamp: Dayjs) {
	return selectedTimestamp.date() < 16
		? selectedTimestamp
				.startOf("month")
				.subtract(2, "weeks")
				.startOf("day")
				.toISOString()
		: selectedTimestamp.startOf("month").startOf("day").toISOString();
}
